import { render, staticRenderFns } from "./Logistica.vue?vue&type=template&id=3ca2e804&scoped=true&"
import script from "./Logistica.vue?vue&type=script&lang=js&"
export * from "./Logistica.vue?vue&type=script&lang=js&"
import style0 from "./Logistica.vue?vue&type=style&index=0&id=3ca2e804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2e804",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
